module.exports = __webpack_public_path__ + "img/chuky-moi.69b8db52.png";